module.exports = __webpack_public_path__ + "img/CubulusIcon.82a3a830.png";